import React from "react";
import { AppPlaceholder } from "@sitecore-content-sdk/nextjs";
import { NoDataFallback } from "../../utils/NoDataFallback";
import { extractHiddenBlock } from "../../utils/styles";
import { PersonalizationContentZoneProps } from "components/personalization-content-zone/personalization-content-zone.props";
import componentMap from ".sitecore/component-map";

export const Default: React.FC<PersonalizationContentZoneProps> = (props) => {
  console.log("---->[PersonalizationContentZone] Component", props.fields);

  const { page, fields, params, rendering } = props;

  const styles = `${params?.Styles ?? ""}`.trimEnd();
  const phKey = `personalization-content-zone-${params?.DynamicPlaceholderId}`;

  const id = params?.RenderingIdentifier;

  const hiddenBlockStyles = extractHiddenBlock(params?.GridParameters);

  const computedStyles = (): React.CSSProperties => {
    if (page.mode.isEditing) {
      return {
        width: "100%",
        minHeight: "100px",
        border: "1px dashed #ccc",
        padding: "10px",
        backgroundColor: "#e8e8e8",
      };
    }
    return {};
  };

  if (fields) {
    return (
      <React.Fragment>
        {(page.mode.isEditing || !!fields.ContentZoneName?.value) && (
          <div
            className={`${styles} ${hiddenBlockStyles}`}
            style={computedStyles()}
            id={id ?? undefined}
            data-evg-component={fields?.ContentZoneName?.value}
          >
            {page.mode.isEditing && (
              <p>
                Personalization Content Zone:{" "}
                <strong>{fields?.ContentZoneName?.value}</strong>
              </p>
            )}
            <div
              className={`${page.mode.isEditing ? "bg-white pz-editing-wrapper" : ""}`}
            >
              <AppPlaceholder
                name={phKey}
                rendering={rendering}
                page={page}
                componentMap={componentMap}
              />
            </div>
          </div>
        )}
      </React.Fragment>
    );
  }
  return <NoDataFallback componentName="Personalization Content Zone" />;
};
